/**
 * @description Smart Tag Replaceable tokens
 */
export enum TagToken {
	PARTNER_ID = '$PARTNER_ID$',
}